import { AxiosError } from 'axios';

import { IFeedbackModal } from 'components/layout/FeedbackModal';
import { FirebaseErrorCodeEnum } from 'constants/firebase';
import { useFeedbackModal } from 'providers';
import { tooManyRequestsFeedbackModalProps } from 'utils/getAxiosTooManyRequestsFeedbackModalProps';
import { AWAITING_VALIDATION_FEEDBACK } from './constants';

const DEFAULT_ERROR_PROPS: IFeedbackModal = {
  title: 'Authentication Error',
  message: 'Invalid Credentials, please try again.',
  type: 'error',
};

export const useAuthModalError = () => {
  const { openFeedbackModal } = useFeedbackModal();

  const displayAuthErrorModal = (error: unknown): void => {
    if (error instanceof AxiosError) {
      if (error?.response?.status === 429) {
        openFeedbackModal(tooManyRequestsFeedbackModalProps);
        return;
      }

      if (error?.response?.status === 500) {
        openFeedbackModal({
          type: 'error',
          title: 'Internal Server Error',
          message: 'Please try again.',
        });
        return;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      switch (error.response?.data?.code) {
        case FirebaseErrorCodeEnum.RECENT_SIGN_IN_REQUIRED:
          openFeedbackModal({
            type: 'error',
            title: 'Recent sign-in required',
            message: 'Please sign in again.',
          });
          return;
        case FirebaseErrorCodeEnum.AWAITING_VALIDATION:
          openFeedbackModal(AWAITING_VALIDATION_FEEDBACK);
          return;
        case FirebaseErrorCodeEnum.UNAUTHORIZED:
          openFeedbackModal({
            type: 'error',
            title: 'Unauthorized',
            message: 'You do not have authorization to perform this action.',
          });
          return;

        default:
          openFeedbackModal(DEFAULT_ERROR_PROPS);
          return;
      }
    }

    return openFeedbackModal(DEFAULT_ERROR_PROPS);
  };

  return { displayAuthErrorModal };
};
